import { Action, Dispatch } from 'redux'
import { isSameDay } from 'date-fns'
import { db } from 'firebase/index'
import { State } from 'index'
import { hideLoadingAction, showLoadingAction } from 'reducks/loading/actions'
import { SpecialHolidayType } from 'types/calendar'
import { dateToString, parseToDate } from 'lib/helper'
import { fetchSpecialHolidaysAction } from 'reducks/calendar/actions'
import { closeModalAction } from 'reducks/modal/actions'

const saveSpecialHolidays = (dates: Date[]) => {
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    dispatch(showLoadingAction())

    const specialHolidays = getState().calendar.specialHolidays
    const calendarsRef = db.collection('calendars')
    const batch = db.batch()
    const nextState: SpecialHolidayType[] = []

    // 更新前には存在していたが、選択状態ではない日付を削除
    for (let i = 0; i < specialHolidays.length; i = (i + 1) | 0) {
      const specialHoliday = specialHolidays[i]
      if (!dates.some((date) => isSameDay(date, parseToDate(specialHoliday.date)))) {
        batch.delete(calendarsRef.doc(`calendar-${specialHoliday.date}`))
      }
    }

    for (let i = 0; i < dates.length; i = (i + 1) | 0) {
      const date = dateToString(dates[i])
      const value = { date: date, description: '', is_holiday: true }
      nextState.push(value)
      batch.set(calendarsRef.doc(`calendar-${date}`), value, { merge: true })
    }

    return batch
      .commit()
      .then(() => {
        nextState.sort((a, b) => (a.date < b.date ? -1 : 1))
        dispatch(fetchSpecialHolidaysAction(nextState))
        dispatch(hideLoadingAction())
        dispatch(closeModalAction())
      })
      .catch((error) => {
        dispatch(hideLoadingAction())
        console.error(error)
      })
  }
}

export default saveSpecialHolidays
